// ============================================================
// sale-content/sections.js — ตั้งค่าของแต่ละ section ในหน้า "เนื้อหาหน้าเว็บขาย"
// ------------------------------------------------------------
// ★ ทุกอย่างในไฟล์นี้อิงจากสิ่งที่เว็บขาย (CDS-Sale-Landing-Page) แสดงจริง
//   src/page/home/index.js + src/page/home/components/Home*.js
//   ฟอร์มจึงโชว์เฉพาะช่องที่หน้าเว็บหยิบไปใช้ ช่องที่ไม่มีผลบนเว็บจะไม่ให้กรอก
//
// ★ key ต้องตรงกับ SECTION_LIST ฝั่ง backend
//   (CDS-P2-Backend/modules/sale-page-content/sale-page-content.service.js)
//   ส่วน "gallery" ถูกตัดทิ้งแล้ว (เว็บไม่ได้แสดง) จึงไม่มีในรายการนี้
//
// ★ GLOBAL_SECTIONS ต้องตรงกับฝั่ง backend — section กลาง backend เก็บด้วย project_id = null
//   เนื้อหาหน้าเว็บขายเป็น "ตั้งค่ากลาง" ชุดเดียวทั้งเว็บ ทุก section ใช้ร่วมกันทุกโครงการ
//   (ตัดสินใจ 16/09/2026 · GLOBAL_SECTIONS ประกาศไว้ใต้ SECTIONS)
// ============================================================

export const isGlobalSection = (key) => GLOBAL_SECTIONS.includes(key);

// ---------- ไอคอน ----------
// รหัสตัวอักษร FontAwesome ชุด light (ฟอนต์เดียวกับเว็บขาย ดู icons.js ของเว็บขาย)
// ★ ห้ามมีรหัสซ้ำในชุดเดียวกัน — ใช้รหัสเป็น key ของปุ่ม ซ้ำแล้วเลือกทีเดียวติดสองปุ่ม
export const ICONS_GENERAL = [
  { code: "", label: "บ้าน" },
  { code: "", label: "คอนโด/อาคาร" },
  { code: "", label: "ทาวน์โฮม" },
  { code: "", label: "อาคารพาณิชย์" },
  { code: "", label: "กุญแจ/เช่า" },
  { code: "", label: "ป้ายราคา" },
  { code: "", label: "เงิน" },
  { code: "", label: "โปรโมชั่น" },
  { code: "", label: "ประกาศ" },
  { code: "", label: "ดาว" },
  { code: "", label: "มงกุฎ" },
  { code: "", label: "หัวใจ" },
  { code: "", label: "ห้องนอน" },
  { code: "", label: "ห้องน้ำ" },
  { code: "", label: "ที่จอดรถ" },
  { code: "", label: "เลี้ยงสัตว์ได้" },
  { code: "", label: "รถไฟฟ้าใต้ดิน" },
  { code: "", label: "รถไฟฟ้า" },
  { code: "", label: "สนามบิน" },
  { code: "", label: "ใกล้สถานศึกษา" },
  { code: "", label: "โรงพยาบาล" },
  { code: "", label: "ห้าง/ร้านค้า" },
  { code: "", label: "สวน/ธรรมชาติ" },
  { code: "", label: "น่าลงทุน" },
  { code: "", label: "โฮมออฟฟิศ" },
  { code: "", label: "บริการ" },
  { code: "", label: "สินเชื่อ" },
  { code: "", label: "ทีมงาน" },
  { code: "", label: "ปลอดภัย" },
  { code: "", label: "ตรวจสอบแล้ว" },
  { code: "", label: "เวลา" },
  { code: "", label: "ผู้ช่วย/สายด่วน" },
  { code: "", label: "รวดเร็ว" },
  { code: "", label: "ค้นหา" },
  { code: "", label: "ทำเล" },
  { code: "", label: "พื้นที่" },
  { code: "", label: "เอกสาร" },
];

// ฟอนต์ที่เว็บขายโหลดไม่มีชุดไอคอนแบรนด์ (Facebook/LINE) จึงใช้ไอคอนทั่วไปแทน
export const ICONS_SOCIAL = [
  { code: "", label: "เว็บไซต์/ทั่วไป" },
  { code: "", label: "แชต (LINE/Messenger)" },
  { code: "", label: "วิดีโอ (YouTube/TikTok)" },
  { code: "", label: "รูปภาพ (Instagram)" },
  { code: "", label: "เพจ/กลุ่ม (Facebook)" },
  { code: "", label: "แชร์" },
  { code: "", label: "โทรศัพท์" },
  { code: "", label: "อีเมล" },
];

// ---------- ทางลัดค้นหา ----------
// ★ ชุดช่วงราคาต้องตรงกับ SALE_BUDGETS / RENT_BUDGETS ใน CDS-Sale-Landing-Page/src/page/home/index.js
//   หน้าเว็บอ่าน link_url แบบ query string แล้วเอา listing_type / budget / data_search ไปใส่ตัวกรอง
//   (ค่าอื่นถูกทิ้ง) — budget ที่ไม่อยู่ในชุดจะยังกรองได้ แต่ช่องเลือกราคาบนเว็บจะแสดงว่าง
export const LISTING_TYPES = [
  { value: "", label: "ทั้งขายและเช่า" },
  { value: "ขาย", label: "ประกาศขาย" },
  { value: "เช่า", label: "ประกาศให้เช่า" },
];

export const SALE_BUDGETS = [
  { value: "", label: "ทุกช่วงราคา" },
  { value: "0-1500000", label: "ไม่เกิน 1.5 ล้าน" },
  { value: "1500001-2500000", label: "1.5 - 2.5 ล้าน" },
  { value: "2500001-4000000", label: "2.5 - 4 ล้าน" },
  { value: "4000001-", label: "มากกว่า 4 ล้าน" },
];

export const RENT_BUDGETS = [
  { value: "", label: "ทุกช่วงราคา" },
  { value: "0-6000", label: "ไม่เกิน 6,000 บาท" },
  { value: "6001-10000", label: "6,001 - 10,000 บาท" },
  { value: "10001-15000", label: "10,001 - 15,000 บาท" },
  { value: "15001-", label: "มากกว่า 15,000 บาท" },
];

// หน้าเว็บใช้ชุดราคาเช่าเฉพาะตอนเลือก "เช่า" นอกนั้น (รวมไม่เลือก) ใช้ชุดราคาขาย
export const budgetsFor = (listingType) => (listingType === "เช่า" ? RENT_BUDGETS : SALE_BUDGETS);

export const parseShortcut = (linkUrl) => {
  const params = new URLSearchParams(linkUrl || "");
  return {
    listing_type: params.get("listing_type") || "",
    budget: params.get("budget") || "",
    data_search: params.get("data_search") || "",
  };
};

// เก็บเฉพาะค่าที่เลือก — ว่างทั้งหมด = กดแล้วล้างตัวกรองเป็น "ดูทั้งหมด"
export const buildShortcut = ({ listing_type, budget, data_search }) => {
  const params = new URLSearchParams();
  if (listing_type) params.set("listing_type", listing_type);
  if (budget) params.set("budget", budget);
  if ((data_search || "").trim()) params.set("data_search", data_search.trim());
  return params.toString();
};

export const describeShortcut = (linkUrl) => {
  const f = parseShortcut(linkUrl);
  const parts = [];
  if (f.listing_type) parts.push(LISTING_TYPES.find((i) => i.value === f.listing_type)?.label || f.listing_type);
  if (f.budget) parts.push(budgetsFor(f.listing_type).find((i) => i.value === f.budget)?.label || `ช่วงราคา ${f.budget}`);
  if (f.data_search) parts.push(`คำค้น "${f.data_search}"`);
  return parts.length ? parts.join(" · ") : "แสดงห้องทั้งหมด (ล้างตัวกรอง)";
};

// ลิงก์โซเชียลต้องเป็น URL เต็ม — พิมพ์มาแค่ facebook.com/xxx ให้เติม https:// ให้
export const normalizeUrl = (value) => {
  const v = String(value || "").trim();
  if (!v) return "";
  if (/^(https?:|mailto:|tel:)/i.test(v)) return v;
  return `https://${v.replace(/^\/+/, "")}`;
};

// ---------- section ----------
// fields: ช่องที่ฟอร์มแสดง (เรียงตามลำดับในฟอร์ม)
//   type = text | textarea | icon | image | shortcut | url
//   key  = ชื่อคอลัมน์ใน SalePageContents (shortcut/url เขียนลง link_url, image เขียนลง image_url)
// single: หน้าเว็บหยิบแค่ "ชิ้นแรกที่เปิดแสดง" ไปใช้
// webEmpty: หน้าเว็บทำอะไรเมื่อ section นี้ไม่มีรายการที่เปิดแสดง
export const SECTIONS = [
  {
    key: "background",
    label: "ภาพพื้นหลังเว็บไซต์",
    desc: "ภาพใหญ่ด้านบนสุด ใช้ร่วมทุกโครงการ",
    where: "ฉากหลังของแถบบนสุดในหน้าแรก (หลังพาดหัวและกล่องค้นหา) ใส่หลายภาพ = เล่นวนเป็นสไลด์ทุก 6 วินาที",
    webEmpty: "ไม่มีภาพที่เปิดใช้ หน้าเว็บจะเป็นพื้นไล่สีธรรมดา",
    custom: "background",
  },
  {
    key: "hero",
    label: "พาดหัวหน้าแรก",
    desc: "ข้อความใหญ่บนสุด + คำโปรย",
    where: "ข้อความตัวใหญ่ด้านบนสุดของหน้าแรก วางทับภาพพื้นหลัง อยู่เหนือกล่องค้นหาห้อง",
    webEmpty: 'ใช้ข้อความมาตรฐาน "ห้องชุดประกาศขายและให้เช่า"',
    single: true,
    fields: [
      { key: "title", type: "text", label: "พาดหัว", required: true, maxLength: 255, placeholder: "ห้องชุดประกาศขายและให้เช่า" },
      { key: "subtitle", type: "text", label: "คำโปรยใต้พาดหัว", maxLength: 255, placeholder: "ตรวจสอบสถานะห้องได้จริงทุกห้อง", hint: "เว้นว่าง = ใช้ข้อความมาตรฐาน" },
    ],
    note: 'คำว่า "นิติบุคคล" จะถูกตัดออกอัตโนมัติตอนแสดงบนเว็บ',
  },
  {
    key: "shortcut",
    label: "ปุ่มทางลัดค้นหา",
    desc: "แถวไอคอนใต้กล่องค้นหา",
    where: "แถวปุ่มไอคอนใต้กล่องค้นหา กดแล้วหน้าเว็บจะตั้งตัวกรองให้และเลื่อนลงไปที่รายการห้อง",
    webEmpty: "ไม่แสดงแถวปุ่มทางลัด",
    fields: [
      { key: "icon", type: "icon", label: "ไอคอน", required: true, icons: ICONS_GENERAL },
      { key: "title", type: "text", label: "ชื่อปุ่ม", required: true, maxLength: 255, placeholder: "เช่น ห้องเช่าราคาประหยัด", hint: "สั้น ๆ 1-3 คำ อ่านจบในบรรทัดเดียว" },
      { key: "link_url", type: "shortcut", label: "กดแล้วค้นหาอะไร" },
    ],
  },
  {
    key: "banner",
    label: "แบนเนอร์โปรโมชัน",
    desc: "สไลด์โปรโมตใต้ปุ่มทางลัด",
    where: "แบนเนอร์สไลด์ (เลื่อนเองทุก 6 วินาที) ใต้แถวปุ่มทางลัด ข้างการ์ด \"สนใจห้องไหน ติดต่อได้เลย\"",
    webEmpty: "ไม่แสดงแถวแบนเนอร์ทั้งแถว",
    fields: [
      { key: "image_url", type: "image", label: "ภาพประกอบ", hint: "ไม่ใส่ก็ได้ · ภาพจะถูกคลุมฉากมืดให้ตัวอักษรขาวอ่านออก · แนะนำภาพแนวนอน" },
      { key: "subtitle", type: "text", label: "ป้ายเล็กด้านบน", maxLength: 255, placeholder: "โปรโมชั่น", hint: "เว้นว่าง = ใช้คำว่า \"โปรโมชั่น\"" },
      { key: "title", type: "text", label: "หัวข้อแบนเนอร์", required: true, maxLength: 255, placeholder: "เช่น ผ่อนดาวน์ 0% ถึงสิ้นปี" },
      { key: "body", type: "textarea", label: "รายละเอียด (ฝั่งขวาของแบนเนอร์)", rows: 3, placeholder: "เช่น เฉพาะห้องที่ร่วมรายการ ติดต่อเจ้าหน้าที่เพื่อรับสิทธิ์" },
    ],
    note: "แบนเนอร์บนเว็บกดเป็นลิงก์ไม่ได้ จึงไม่มีช่องลิงก์",
  },
  {
    key: "testimonial",
    label: "รีวิวผู้อยู่อาศัย",
    desc: "กล่อง \"เสียงจากผู้อยู่อาศัย\"",
    where: "กล่อง \"เสียงจากผู้อยู่อาศัย\" ด้านขวาของรายการโครงการ (ใต้รายการห้องประกาศ)",
    webEmpty: "ไม่แสดงกล่องรีวิว",
    fields: [
      { key: "body", type: "textarea", label: "ข้อความรีวิว", required: true, rows: 4, placeholder: "เช่น ส่วนกลางสะอาด เจ้าหน้าที่ดูแลดีมาก เดินทางสะดวก" },
      { key: "title", type: "text", label: "ชื่อผู้รีวิว", required: true, maxLength: 255, placeholder: "เช่น คุณสมศรี" },
      { key: "subtitle", type: "text", label: "สถานะ/ห้อง", maxLength: 255, placeholder: "เช่น ผู้เช่าห้อง A-1203" },
    ],
    note: "กล่องรีวิวจะขึ้นก็ต่อเมื่อหน้าเว็บมีรายการโครงการให้แสดง",
  },
  {
    key: "highlight",
    label: "จุดเด่นโครงการ",
    desc: "การ์ด \"ทำไมต้องเลือก...\"",
    where: "หัวข้อ \"ทำไมต้องเลือกโครงการนี้\" ช่วงล่างของหน้าแรก แสดงเป็นการ์ดไอคอนฝั่งซ้าย",
    webEmpty: "ไม่แสดงการ์ดจุดเด่น (ถ้าไม่มีตัวเลขด้วย จะไม่แสดงทั้งหัวข้อ)",
    fields: [
      { key: "icon", type: "icon", label: "ไอคอน", icons: ICONS_GENERAL, emptyLabel: "ไอคอนมาตรฐาน (โล่)" },
      { key: "title", type: "text", label: "หัวข้อจุดเด่น", required: true, maxLength: 255, placeholder: "เช่น ใกล้รถไฟฟ้า" },
      { key: "body", type: "textarea", label: "คำอธิบาย", rows: 3, placeholder: "เช่น เดินเพียง 5 นาทีถึงสถานี" },
    ],
  },
  {
    key: "stat",
    label: "ตัวเลขความน่าเชื่อถือ",
    desc: "ตัวเลขใหญ่ข้างจุดเด่น",
    where: "แถบตัวเลขฝั่งขวาของหัวข้อ \"ทำไมต้องเลือก...\" (คู่กับจุดเด่นโครงการ)",
    webEmpty: "ไม่แสดงแถบตัวเลข",
    fields: [
      { key: "title", type: "text", label: "ตัวเลข", required: true, maxLength: 255, placeholder: "เช่น 500+", hint: "แสดงตัวใหญ่ พิมพ์ได้ทั้งตัวเลขและหน่วย" },
      { key: "subtitle", type: "text", label: "คำอธิบายตัวเลข", required: true, maxLength: 255, placeholder: "เช่น ห้องที่ดูแล" },
    ],
  },
  {
    key: "faq",
    label: "คำถามที่พบบ่อย",
    desc: "FAQ พับ/กาง + ลิงก์ในฟุตเตอร์",
    where: "หัวข้อ \"คำถามที่พบบ่อย\" ใกล้ท้ายหน้าแรก และ 5 ข้อแรกจะขึ้นเป็นลิงก์ในฟุตเตอร์",
    webEmpty: "ไม่แสดงหัวข้อคำถามที่พบบ่อย",
    fields: [
      { key: "title", type: "text", label: "คำถาม", required: true, maxLength: 255, placeholder: "เช่น ต้องวางเงินมัดจำก่อนเข้าชมห้องไหม" },
      { key: "body", type: "textarea", label: "คำตอบ", required: true, rows: 4, placeholder: "เช่น ไม่ต้อง นัดเข้าชมได้ฟรี" },
    ],
  },
  {
    key: "contact",
    label: "แถบชวนติดต่อ",
    desc: "ข้อความก่อนฟุตเตอร์",
    where: "แถบชวนติดต่อก่อนฟุตเตอร์ (ข้างปุ่ม \"ฝากข้อมูลติดต่อกลับ\") — เบอร์/อีเมล/LINE ในแถบดึงจากหน้า \"การตั้งค่าการขาย (โครงการ) > ข้อมูลบริษัท\"",
    webEmpty: 'ใช้ข้อความมาตรฐาน "สนใจห้องไหน ติดต่อเราได้เลย"',
    single: true,
    fields: [
      { key: "title", type: "text", label: "หัวข้อ", maxLength: 255, placeholder: "สนใจห้องไหน ติดต่อเราได้เลย", hint: "เว้นว่าง = ใช้ข้อความมาตรฐาน" },
      { key: "body", type: "textarea", label: "คำอธิบาย", rows: 2, placeholder: "เจ้าหน้าที่พร้อมให้ข้อมูลและนัดเวลาเข้าชมห้อง", hint: "เว้นว่าง = ใช้ข้อความมาตรฐาน" },
    ],
    atLeastOne: ["title", "body"],
    note: 'คำว่า "นิติบุคคล" จะถูกตัดออกอัตโนมัติตอนแสดงบนเว็บ',
  },
  {
    key: "social",
    label: "ช่องทางโซเชียล",
    desc: "ไอคอน \"ติดตามเรา\" ในฟุตเตอร์",
    where: "ไอคอน \"ติดตามเรา\" ในฟุตเตอร์ กดแล้วเปิดลิงก์ในแท็บใหม่",
    webEmpty: "ไม่แสดงหัวข้อติดตามเรา",
    fields: [
      { key: "icon", type: "icon", label: "ไอคอน", icons: ICONS_SOCIAL, emptyLabel: "ไอคอนมาตรฐาน (ลูกโลก)" },
      { key: "title", type: "text", label: "ชื่อช่องทาง", required: true, maxLength: 255, placeholder: "เช่น Facebook", hint: "ไม่แสดงเป็นตัวหนังสือ ใช้เป็นชื่อเรียกของไอคอน (โปรแกรมอ่านหน้าจอ) และช่วยให้หาในหลังบ้านง่าย" },
      { key: "link_url", type: "url", label: "ลิงก์", required: true, maxLength: 500, placeholder: "https://facebook.com/ชื่อเพจ" },
    ],
    note: "ลิงก์ Facebook ของบริษัทที่กรอกในหน้าข้อมูลบริษัท จะแสดงท้ายฟุตเตอร์แยกต่างหากอยู่แล้ว",
  },
  {
    key: "footer",
    label: "ข้อความฟุตเตอร์",
    desc: "ข้อความสำรองท้ายเว็บ",
    where: "ฟุตเตอร์ท้ายหน้าเว็บ — ใช้เป็นข้อความสำรองเมื่อหน้า \"ข้อมูลบริษัท\" ยังไม่ได้กรอกช่องนั้น",
    webEmpty: 'ใช้ข้อความมาตรฐาน "ตรวจสอบสถานะห้องได้จริงทุกห้อง"',
    single: true,
    fields: [
      { key: "body", type: "textarea", label: "คำอธิบายใต้ชื่อบริษัท", rows: 2, placeholder: "ตรวจสอบสถานะห้องได้จริงทุกห้อง", hint: "แสดงเฉพาะเมื่อ \"ข้อมูลบริษัท\" ยังไม่ได้กรอกที่อยู่บริษัท" },
      { key: "title", type: "text", label: "ชื่อในบรรทัดลิขสิทธิ์ (©)", maxLength: 255, placeholder: "ห้องประกาศขาย/ให้เช่า", hint: "แสดงเฉพาะเมื่อ \"ข้อมูลบริษัท\" ยังไม่ได้กรอกชื่อบริษัท (ไทย)" },
    ],
    atLeastOne: ["title", "body"],
  },
];

// ทุก section เป็นของกลาง (ดูหัวไฟล์)
export const GLOBAL_SECTIONS = SECTIONS.map((s) => s.key);

// กลุ่มในเมนูซ้าย — เรียงตามตำแหน่งบนหน้าเว็บจากบนลงล่าง
export const MENU_GROUPS = [
  { label: "ใช้ร่วมทุกโครงการ (เรียงจากบนลงล่างของหน้าเว็บ)", keys: GLOBAL_SECTIONS },
];

export const sectionOf = (key) => SECTIONS.find((s) => s.key === key);

// สรุปเนื้อหา 1 ชิ้นสำหรับแสดงในรายการ (ไม่ใช่หน้าตาจริงบนเว็บ แค่ให้จำได้ว่าชิ้นไหนคืออะไร)
export const summarize = (sectionKey, item) => {
  const cut = (v, n = 120) => {
    const s = String(v || "").trim();
    return s.length > n ? `${s.slice(0, n)}…` : s;
  };
  switch (sectionKey) {
    case "shortcut":
      return { icon: item.icon, title: item.title, sub: describeShortcut(item.link_url) };
    case "banner":
      return { image: item.image_url, kicker: item.subtitle || "โปรโมชั่น", title: item.title, sub: cut(item.body) };
    case "testimonial":
      return { title: item.title, kicker: item.subtitle, sub: cut(item.body) };
    case "highlight":
      return { icon: item.icon || "", title: item.title, sub: cut(item.body) };
    case "stat":
      return { big: item.title, sub: item.subtitle };
    case "faq":
      return { title: item.title ? `ถาม: ${item.title}` : "", sub: item.body ? `ตอบ: ${cut(item.body)}` : "" };
    case "social":
      return { icon: item.icon || "", title: item.title, sub: item.link_url };
    default:
      return { title: item.title, sub: cut(item.subtitle || item.body) };
  }
};
